// Single source of truth for the primary navigation per role, shared by
// the mobile BottomBar and the desktop Sidebar so the two never drift.
// Extracted verbatim from BottomBar's original inline definitions.

// Each tab: [pageId, iconName, label]
export function navTabs(role, t) {
  if (role === "landlord") {
    return [["dash", "home", t.dashboard], ["pay", "dollar", t.payments], ["maint", "wrench", t.maintenance], ["chatList", "msg", t.chat]];
  }
  if (role === "service") {
    return [["dash", "home", t.dashboard], ["spJobs", "wrench", t.myJobs], ["mapView", "mapPin", t.mapView || "Map"], ["spHistory", "file", t.history], ["spEarnings", "dollar", t.earnings]];
  }
  // tenant / default
  return [["dash", "home", t.myHouse], ["mapView", "mapPin", t.mapView || "Map"], ["pay", "dollar", t.myPay], ["maint", "wrench", t.maintenance], ["tenChat", "msg", t.chat]];
}

// Maps sub-pages → their parent tab so the active tab highlights correctly.
export function navTabMap(role) {
  return {
    spJobDetail: "spJobs", props: "dash", tens: "dash", propDetail: "dash", editProp: "dash",
    addProp: "dash", addTenant: "dash", editTenant: "dash", tenantDetail: "dash", inviteTenant: "dash",
    tenantPayHistory: "pay", addPay: "pay", paySettings: "pay", ccForm: "cc", agreement: "dash",
    servicePersons: "dash", addServicePerson: "dash", editServicePerson: "dash", subMaint: "maint",
    tenPay: "pay", tenAgr: "settings", faq: "settings", leases: "dash", leaseDetail: "dash",
    leaseForm: "dash", editLease: "dash", tenLease: "dash", leads: "dash",
    ...(role === "landlord" ? { mapView: "dash" } : { mapView: "mapView" }),
  };
}

// Per-tab plan-feature gate (mirrors BottomBar's TAB_FEATURE).
export const TAB_FEATURE = { maint: "maintenance" };
